import script from "./Tabs.vue?vue&type=script&lang=ts&setup=true"
export * from "./Tabs.vue?vue&type=script&lang=ts&setup=true"

import "./Tabs.vue?vue&type=style&index=0&id=69ff8ca8&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/curl-fe-build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69ff8ca8"]])

export default __exports__